<template>
	<div class="app-container">

		<el-form v-model="configForm" label-position="right" label-width="200px" @submit.native.prevent="handleUpdate">
			<el-row :gutter="0">
				<el-col :span="8">
					<el-form-item label="问题文件最大数量">
						<el-input v-model="configForm.maxProblemFileCount" />
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="答案文件最大数量">
						<el-input v-model="configForm.maxAnswerFileCount" />
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="答案评论文件最大数量">
						<el-input v-model="configForm.maxAsCommentFileCount" />
					</el-form-item>
				</el-col>
			</el-row>

			<el-row :gutter="0">
				<el-col :span="8">
					<el-form-item label="答案模块最大语音数量">
						<el-input v-model="configForm.maxAnswerVoiceCount" />
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="最大可置顶数">
						<el-input v-model="configForm.maxTopCount" />
					</el-form-item>
				</el-col>
			</el-row>

			<el-row :gutter="0">
				<el-col :span="8">
					<el-form-item label="问题麦粒值最小值">
						<el-input v-model="configForm.minProblemMaiValue" />
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="最佳答案奖励">
						<el-input v-model="configForm.bestAnswerPay" />
					</el-form-item>
				</el-col>
			</el-row>

			<el-row :gutter="0">
				<el-col :span="8">
					<el-form-item label="用户是否需要自主邀请专家">
						<el-select v-model="configForm.isNeedInviteUltraExpert" style="width: 100%">
							<el-option label="是" :value="true" />
							<el-option label="否" :value="false" />
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="邀请专家的最大允许数量">
						<el-input v-model="configForm.maxUltraExpertNum" />
					</el-form-item>
				</el-col>
			</el-row>

			<el-row :gutter="0">
				<el-col :span="8">
					<el-form-item label="一级专家可以获得的麦粒值">
						<el-input v-model="configForm.levelOneMai" />
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="二级专家可以获取的麦粒值">
						<el-input v-model="configForm.levelTwoMai" />
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="三级专家可以获取的麦粒值">
						<el-input v-model="configForm.levelThreeMai" />
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="0">
				<el-form-item>
					<el-button type="primary" size="small" native-type="submit">保存</el-button>
				</el-form-item>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import {
		getProblemConfig,
		updateProblemConfig,
	} from "@/api/mai/quizManagement/quizManagement";
	import {
		handleRes
	} from "@/utils/handleRes"
	import {
		printObj
	} from "@/utils/debug"

	export default {
		data() {
			return {
				configForm: {}, // 模块配置表单
			}
		},
		created() {
			this.getProblemConfig();
		},
		methods: {

			/**
			 * 获取问题配置列表
			 */
			getProblemConfig() {
				this.loading = true;
				const params = {};

				getProblemConfig(params).then((res) => {
					handleRes(res, () => {
						// printObj(res.data)
						this.configForm = res.data
					})
					this.utils.stopLoading(this);
				});
			},
			/**
			 * @description: 更新问题模块配置
			 * @param {*}
			 * @return {*}
			 */
			handleUpdate() {

				updateProblemConfig(this.configForm).then((res) => {
					handleRes(res, );
				});
			},
		},
	}
</script>

<style>
</style>
